<p-toast class="bl-toast bl-toast--success" key="successFormUser"></p-toast>
<p-toast class="bl-toast bl-toast--success" key="successDeleteUser"></p-toast>
<p-toast class="bl-toast bl-toast--success" key="successDisableUser"></p-toast>
<!-- <p-dialog
  header="Cancel entry"
  [(visible)]="display"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [baseZIndex]="10000"
  [closable]="false"
  styleClass="bl-modal"
  [positionTop]="65"
  [positionLeft]="390"
>
  <p>Are you sure want to cancel to entry?
  </p>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="toggleDialog()"
      label="No"
    ></button>
    <button
      type="button"
      pButton
      (click)="cancelEntry()"
      label="Yes"
      class="ui-button-secondary"
    ></button>
  </p-footer>
</p-dialog> -->
<!-- <p-dialog
  header="Delete user"
  [(visible)]="displayDelete"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [baseZIndex]="10000"
  [closable]="false"
  styleClass="bl-modal"
  [positionTop]="65"
  [positionLeft]="390"
>
  <p>
    Are you sure do you want to delete the user -- ?
  </p>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="toggleDialogDelete()"
      label="Cancel"
    ></button>
    <button
      type="button"
      pButton
      (click)="removeUser(deleteUser, colUser)"
      label="Delete user"
      class="ui-button-secondary"
    ></button>
  </p-footer>
</p-dialog> -->
<!-- <p-dialog
  header="Disable user"
  [(visible)]="displayDisable"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [baseZIndex]="10000"
  [closable]="false"
  styleClass="bl-modal"
  [positionTop]="65"
  [positionLeft]="390"
>
  <p>Selected user will be disabled.
  </p>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="toggleDialogDisable()"
      label="No"
    ></button>
    <button
      type="button"
      pButton
      (click)="removeUser(deleteUser, colUser)"
      label="Yes"
      class="ui-button-secondary"
    ></button>
  </p-footer>
</p-dialog> -->

<!-- ------------------------------------------ -->
<bid-modal-users
  [opened]="displayDelete"
  [headerText]="'Delete user'"
  [contentText]="'Are you sure you want to delete the user'"
  [submitBtnText]="'Delete user'"
  [user]="userData"
  (closed)="deleteUser($event)"
>
</bid-modal-users>
<!-- ------------------------------------------ -->

<p-table [columns]="headerTable" [value]="bodyTable" [responsive]="true" sortMode="multiple">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th
        [ngClass]="{
          sortable: col.field === 'userType' || col.field === 'displayName' || col.field === 'mail'
        }"
        *ngFor="let col of columns"
        [pSortableColumn]="col.field"
        [pSortableColumnDisabled]="col.field === 'department' || col.field === 'actions'"
        [ngStyle]="{ width: col.width }"
      >
        {{ col.header }}
        <p-sortIcon
          *ngIf="col.field === 'userType' || col.field === 'displayName' || col.field === 'mail'"
          [field]="col.field"
          ariaLabel="Activate to sort"
          ariaLabelDesc="Activate to sort in descending order"
          ariaLabelAsc="Activate to sort in ascending order"
        >
        </p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
    <tr>
      <td *ngFor="let col of columns">
        <div [ngSwitch]="col.field">
          <!-- <div *ngSwitchCase="'userType'">
            <span *ngIf="updateRoleUser !== i">{{ rowData[col.field] }}</span>
            <p-dropdown
              *ngIf="updateRoleUser === i"
              [options]="rolesCombo"
              [(ngModel)]="rowData[col.field]"
              value="rowData[col.field]"
              name="'role-' + i"
              [formControlName]="'role-' + i"
              defaultLabel="select"
              styleClass="bl-dropdown"
            ></p-dropdown>
          </div> -->
          <div *ngSwitchCase="'displayName'">
            <span *ngIf="updateRoleUser !== i">{{ rowData[col.field] }}</span>
            <div *ngIf="updateRoleUser === i" class="bl-chips">
              <p-chips class="bl-chips" name="'name-' + i" max="'1'"></p-chips>
            </div>
          </div>
          <div *ngSwitchCase="'mail'">
            <span *ngIf="updateRoleUser !== i">{{ rowData[col.field] }}</span>
            <div *ngIf="updateRoleUser === i" class="bl-chips">
              <p-chips class="bl-chips" name="'email-' + i" max="'1'"></p-chips>
            </div>
          </div>
          <!-- <div *ngSwitchCase="'department'">
            <span>{{ rowData[col.field] }}</span>
          </div>
          <div *ngSwitchCase="'actions'">
            <div *ngIf="updateRoleUser !== i">
              <a (click)="removeUser(rowData, i)" class="bl-users__icon">
                <i class="far fa-trash-alt"></i>
              </a>
              <a (click)="updateUser(i)" class="bl-users__icon">
                <i class="fas fa-pencil-alt"></i>
              </a>
            </div>

            <div *ngIf="updateRoleUser === i">
              <a (click)="noUpdate()" class="bl-users__icon">
                <i class="fas fa-times"></i>
              </a>
              <a (click)="saveUser(rowData, i)" class="bl-users__icon">
                <i class="fas fa-check"></i>
              </a>
            </div>
          </div> -->
          <div *ngSwitchCase="'delete'">
            <span class="bl-button bl-button--icon" (click)="toggleDialogDelete(rowData, true)">
              <i class="far fa-trash-alt bl-users__icon"></i>
            </span>
          </div>
          <div *ngSwitchCase="'status'">
            <p-inputSwitch
              [(ngModel)]="rowData[col.field]"
              (onChange)="updateStatus(rowData)"
              class="bl-switch"
            ></p-inputSwitch>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
